module.exports = __webpack_public_path__ + "assets/logout.557880f7.svg";